var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { ref: "add-room-form" },
    [
      _c("model-field", {
        attrs: { label: "Name", type: "text", stateless: "" },
        model: {
          value: _vm.venueData.name,
          callback: function ($$v) {
            _vm.$set(_vm.venueData, "name", $$v)
          },
          expression: "venueData.name",
        },
      }),
      _vm._v(" "),
      _c("model-field", {
        attrs: { label: "Address", type: "text", stateless: "" },
        model: {
          value: _vm.venueData.address,
          callback: function ($$v) {
            _vm.$set(_vm.venueData, "address", $$v)
          },
          expression: "venueData.address",
        },
      }),
      _vm._v(" "),
      _vm.showButtons
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                { attrs: { variant: "link" }, on: { click: _vm.clear } },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.saveVenue } },
                [_vm._v("Save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }